import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PaginationService } from '../../../../services/pagination/pagination.service';

@Component({
  selector: 'app-page-organization',
  templateUrl: './page-organization.component.html',
})
export class PageOrganizationComponent implements OnInit {

  afficherPerPage = [10, 50, 100];
  affichageSelected = 10;
  idNational: string;
  structure: string;
  nom: string;
  contrat: string;
  raisonSociale: string;
  commune: string;
  structureHabilitee: string;
  structureBeneficiaire: string;

  trierParOptions = [];
  optionSelected: string;

  @Input() type: string;

  constructor(
    private readonly paginationService: PaginationService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.configVariables().subscribe(() => {
      switch (this.type) {
        case 'Structure':
          this.trierParOptions = [this.idNational, this.structure];
          this.optionSelected = this.idNational;
          break;
        case 'Contrat':
          this.trierParOptions = [this.contrat, this.structure];
          this.optionSelected = this.contrat;
          break;
        case 'DetailStructureContrat':
          this.trierParOptions = [this.nom, this.idNational];
          this.optionSelected = this.nom;
          break;
        case 'RaisonSociale':
          this.trierParOptions = [this.raisonSociale, this.idNational, this.commune];
          this.optionSelected = this.raisonSociale;
          break;
        case 'HabilitationPM':
          this.trierParOptions = [this.structureHabilitee, this.structureBeneficiaire];
          this.optionSelected = this.structureBeneficiaire;
          break;
        default:
          this.trierParOptions = [this.structure, this.nom];
          this.optionSelected = this.structure;
          break;
      }
      this.paginationService.calculeData(this.optionSelected, this.type);
    });
  }

  onChangeAffichage(event: any) {
    const n = event.target.value;
    this.affichageSelected = n;
    this.paginationService.changePageActuel(1);
    this.paginationService.changeAfficherPerPage(n);
  }

  onChangeTrierPar(event?: any) {
    const option = event ? event.target.value : this.optionSelected;
    this.optionSelected = option;
    this.paginationService.calculeData(option, this.type);
  }

  configVariables(): Observable<void> {
    return this.translate.get('last').pipe(
      map(() => {
        this.structure = this.translate.instant('trier.structure');
        this.contrat = this.translate.instant('trier.contrat');
        this.idNational = this.translate.instant('trier.idNational');
        this.nom = this.translate.instant('trier.nom');
        this.raisonSociale = this.translate.instant('trier.raisonSociale');
        this.commune = this.translate.instant('trier.commune');
        this.structureBeneficiaire = this.translate.instant('trier.structureBeneficiaire');
        this.structureHabilitee = this.translate.instant('trier.structureHabilitee');
      })
    );
  }
}
